import { FeatureFlag } from '../FeatureFlag';

export const enableTtsAlerts = new FeatureFlag({
    key: 'enable-tts-alerts',
    createdOn: '2026-03-09',
    defaultValue: false,
});
